import { render, staticRenderFns } from "./BAutocompletePermissionInfoModel.vue?vue&type=template&id=ada60ff8&"
import script from "./BAutocompletePermissionInfoModel.vue?vue&type=script&lang=js&"
export * from "./BAutocompletePermissionInfoModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle})
